/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Point} from "../../../models/point";

export class EventPointUi {
  mPoint: Point;
  mImage: createjs.Bitmap;

  setPoint(point: Point): EventPointUi {
    this.mPoint = point;
    return this;
  }
}
